import { render, staticRenderFns } from "./MainManagerFormFields.vue?vue&type=template&id=5f52feb8"
import script from "./MainManagerFormFields.vue?vue&type=script&lang=js"
export * from "./MainManagerFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports